/// <reference types="vite/client" />

const SENTRY = {
    value: import.meta.env.SENTRY_TEST_SEND_URL
}

export const getSentryUrl = () => {
    return SENTRY.value
}

export const setSentryUrl = (url: string) => {
    SENTRY.value = url
}
